import React, { useEffect, useState } from 'react';

const getMenuItems = (role) => {
  const items = [
    { id: 'home', icon: '🏠', label: 'Dashboard' },
    { id: 'schedule', icon: '📅', label: 'Class Schedule' },
  ];

  if (role === 'secretary') {
    items.push({ id: 'attendance', icon: '📋', label: 'Attendance' });
  }
  if (role === 'costume_custodian') {
    items.push({ id: 'costumes', icon: '👘', label: 'Costumes' });
  }
  if (role === 'instrument_custodian') {
    items.push({ id: 'instruments', icon: '🎵', label: 'Instruments' });
  }
  if (role === 'treasurer') {
    items.push({ id: 'fines', icon: '💰', label: 'Fines' });
  }
  if (role === 'president' || role === 'vice_president') {
    items.push({ id: 'members', icon: '👥', label: 'Members' });
    items.push({ id: 'announcement', icon: '📢', label: 'Announcement' });
  }

  return items;
};

const MemberSidebar = ({ isOpen, activePage, setActivePage, onClose, member }) => {
  const [currentRole, setCurrentRole] = useState(member?.role);

  useEffect(() => {
    setCurrentRole(member?.role);
  }, [member?.role]);

  const menuItems = getMenuItems(currentRole);

  const handleClick = (id) => {
    setActivePage(id);
    onClose();
  };

  return (
    <div style={{ ...styles.sidebar, left: isOpen ? '0' : '-280px' }}>
      {/* Header */}
      <div style={styles.sidebarHeader}>
        <div style={styles.memberInfo}>
          <div style={styles.avatar}>
            {member?.first_name?.charAt(0)}{member?.last_name?.charAt(0)}
          </div>
          <div>
            <p style={styles.memberName}>
              {member?.first_name} {member?.last_name}
            </p>
            <p style={styles.memberRole}>
              {member?.role?.replace('_', ' ')}
            </p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <div style={styles.menuList}>
        {menuItems.map(item => (
          <button
            key={item.id}
            style={{
              ...styles.menuItem,
              ...(activePage === item.id ? styles.menuItemActive : {}),
            }}
            onClick={() => handleClick(item.id)}
          >
            <span style={styles.menuIcon}>{item.icon}</span>
            <span style={styles.menuLabel}>{item.label}</span>
            {activePage === item.id && <div style={styles.activeBar} />}
          </button>
        ))}
      </div>

      {/* Footer */}
      <div style={styles.sidebarFooter}>
        <p style={styles.footerText}>Dulimbay System v1.0</p>
        <p style={styles.footerText}>Caraga State University</p>
      </div>
    </div>
  );
};

const styles = {
  sidebar: {
    position: 'fixed', top: '65px', left: '-280px',
    width: '260px', height: 'calc(100vh - 65px)',
    background: 'linear-gradient(180deg, #1a1a2e 0%, #16213e 100%)',
    zIndex: 999, transition: 'left 0.3s ease',
    display: 'flex', flexDirection: 'column',
    boxShadow: '4px 0 20px rgba(0,0,0,0.3)',
    overflowY: 'auto',
  },
  sidebarHeader: {
    padding: '20px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
  memberInfo: {
    display: 'flex', alignItems: 'center', gap: '12px',
  },
  avatar: {
    width: '44px', height: '44px', borderRadius: '50%',
    background: '#e74c3c', color: 'white',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontWeight: 'bold',
    fontSize: '16px', flexShrink: 0,
  },
  memberName: {
    color: 'white', fontWeight: 'bold',
    fontSize: '14px', margin: '0 0 3px 0',
  },
  memberRole: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: '12px', margin: 0,
    textTransform: 'capitalize',
  },
  menuList: { flex: 1, padding: '15px 0' },
  menuItem: {
    width: '100%', padding: '14px 20px',
    background: 'none', border: 'none',
    cursor: 'pointer', display: 'flex',
    alignItems: 'center', gap: '12px',
    color: 'rgba(255,255,255,0.7)',
    fontSize: '14px', textAlign: 'left',
    position: 'relative', transition: 'all 0.2s',
  },
  menuItemActive: {
    background: 'rgba(255,255,255,0.1)',
    color: 'white', fontWeight: 'bold',
  },
  menuIcon: { fontSize: '18px', width: '24px', textAlign: 'center' },
  menuLabel: { flex: 1 },
  activeBar: {
    position: 'absolute', right: '0', top: '0', bottom: '0',
    width: '4px', background: '#e74c3c',
    borderRadius: '4px 0 0 4px',
  },
  sidebarFooter: {
    padding: '20px',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    textAlign: 'center',
  },
  footerText: {
    color: 'rgba(255,255,255,0.3)',
    fontSize: '11px', margin: '2px 0',
  },
};

export default MemberSidebar;